
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hyt888",
      function () {
        return require("private-next-pages/hyt888/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hyt888"])
      });
    }
  